module.exports = {"available":"Voľné","booked":"Rezervované","occupied":"Occupied","booked-occupied":"Rezervované / Occupied","used":"used","until":"Do","all-day":"Celodenne","page_over_total":"Strana {page} z {total}","room-name":"Názov miestnosti","current-booking":"Aktuálne","next-booking":"Ďalšie","unknown":"Neznámy","floors":"Poschodia","today":"Dnes","no_bookings":"Žiadne stretnutia plánováne na dnes","no_information":"Žiadne informácie","description":"Description","capacity":"Capacity","allocated":"Allocated","booked-occupied-allocated":"Rezervované / Occupied / Allocated"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/sk.json
// module id = BjaG
// module chunks = 2